import { render } from "./PerfilIcon.vue?vue&type=template&id=05c406c2&scoped=true"
import script from "./PerfilIcon.vue?vue&type=script&lang=js"
export * from "./PerfilIcon.vue?vue&type=script&lang=js"

import "./PerfilIcon.vue?vue&type=style&index=0&id=05c406c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c406c2"]])

export default __exports__